import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import LogTheme from './LogTheme';
import { useAuth } from '../../contexts/AuthContext';

function ShowProfile() {
    const [profile, setProfile] = useState(null);
    const { userid } = useParams();
    const currentUser = useAuth();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [zoomedImageIndex, setZoomedImageIndex] = useState(null); // Add this line


    console.log('currentUser i ShowProfile: ', currentUser.userId);

    useEffect(() => {
        if (userid !== currentUser.userId && currentUser.role !== 'admin') {
            setLoading(false);
            // Om userId inte är tillgängligt, vänta på nästa render för att göra fetch-anropet
            navigate('/info');
            return;
        }

        fetch(`${process.env.REACT_APP_SERVER_URL}/api/showprofile/${userid}`)
            .then(response => response.json())
            .then(data => {
                console.log('Response data:', data);
                setProfile(data);
            })
            .catch(error => {
                console.error('Error:', error);
            })
            .finally(() => setLoading(false));
    }, [userid, currentUser]);

    if (loading) {
        return <div>
            <h2 style={{ margin: 25 }}>Laddar sidan ...</h2></div>;
    }

    console.log('log ', profile);
    if (!profile) {
        return <div>
            <h2 style={{ margin: 25 }}>Profilen kunde inte hämtas.</h2>
        </div>;
    }

    return (
        <LogTheme>
            <div>
                <Box padding={2}>
                    <Card sx={{ padding: 4 }}>
                        <CardContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Link to={`/changeprofile/${userid}`}>
                                    <Button variant="contained" color="primary">Ändra</Button>
                                </Link>
                            </div>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" marginRight={2}>Användarnamn:</Typography>
                                <Typography variant="h4">{profile.username}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" marginRight={2}>E-post:</Typography>
                                <Typography variant="h4">{profile.email}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" marginRight={2}>Förnamn:</Typography>
                                <Typography variant="h4">{profile.firstName}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" marginRight={2}>Efternamn:</Typography>
                                <Typography variant="h4">{profile.lastName}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" marginRight={2}>Beskrivning:</Typography>
                                <Typography variant="h4">{profile.bio}</Typography>
                            </Box>
                        </CardContent>
                    </Card>
                    <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
                        {
                            profile.profilePictures.map((imageUrl, index) => {
                                const isZoomed = zoomedImageIndex === index; // Add this line

                                return (
                                    <Box
                                        padding={2}
                                        key={index}
                                        width={300}
                                        sx={{
                                            transition: 'transform 0.2s',
                                            transform: isZoomed ? 'scale(2)' : 'none',
                                            top: isZoomed ? '50%' : '0',
                                            left: isZoomed ? '50%' : '0',
                                            margin: isZoomed ? '0 auto' : '0',
                                            zIndex: isZoomed ? 9999 : 'auto',
                                        }}
                                        onClick={() => setZoomedImageIndex(isZoomed ? null : index)} // Change this line
                                    >
                                        <Card sx={{ padding: 1 }}>
                                            <CardContent>
                                                {typeof imageUrl === 'string' && (
                                                    <img
                                                        src={imageUrl.replace('/profile-pictures/', `${process.env.REACT_APP_SERVER_URL}/api/profile-pictures/`)}
                                                        alt={`Image ${index}`}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    />
                                                )}
                                            </CardContent>
                                        </Card>
                                    </Box>
                                );
                            })
                        }
                    </Box>
                </Box>
            </div>
        </LogTheme>
    );
}

export default ShowProfile;